import(/* webpackMode: "eager", webpackExports: ["Timeline"] */ "/vercel/path0/apps/golden-visa/components/ClientComponents.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["OptionalTracker"] */ "/vercel/path0/libs/analytics/src/lib/Analytics.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/libs/atoms/src/lib/components/icons/icons.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/libs/atoms/src/lib/components/typography/AnchorCopyTooltip.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WistiaExternal"] */ "/vercel/path0/libs/embedded-data-provider/src/lib/components/WistiaVariant/WistiaExternal.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WistiaVideoSchema"] */ "/vercel/path0/libs/embedded-data-provider/src/lib/components/WistiaVariant/WistiaVideoSchema.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ErrorBoundary"] */ "/vercel/path0/libs/error-boundary/src/lib/ErrorBoundary.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TestErrorTrigger"] */ "/vercel/path0/libs/error-boundary/src/lib/TestErrorTrigger.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/libs/forms/src/gravity-form/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AlternatePageMediator"] */ "/vercel/path0/libs/intl/src/lib/page-alternates/AlternatePageMediator.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AlternatePageProvider"] */ "/vercel/path0/libs/intl/src/lib/page-alternates/AlternatePageProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AlternatePageSwitcher"] */ "/vercel/path0/libs/intl/src/lib/page-alternates/AlternatePageSwitcher.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/libs/molecules/src/lib/components/blocks/call-to-action/blocks/Factsheet/Popup.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AnalyticsClient"] */ "/vercel/path0/libs/molecules/src/lib/components/blocks/call-to-action/components/AnalyticsClient/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ClientClickOnServerLinkElement"] */ "/vercel/path0/libs/molecules/src/lib/components/blocks/call-to-action/components/ClientClickOnServerLinkElement.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/libs/molecules/src/lib/components/blocks/call-to-action/components/NewC2ALinkClient.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/libs/molecules/src/lib/components/blocks/call-to-action/components/PreviewDetails.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ScrollHandImage"] */ "/vercel/path0/libs/molecules/src/lib/components/blocks/table/components/CardViewSlider/ScrollHandImage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Carousel"] */ "/vercel/path0/libs/molecules/src/lib/components/carousel/Carousel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FullscreenCarousel"] */ "/vercel/path0/libs/molecules/src/lib/components/carousel/FullscreenCarousel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PaginationCarousel"] */ "/vercel/path0/libs/molecules/src/lib/components/carousel/PaginationCarousel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/libs/molecules/src/lib/components/spoilers/AccordionSpoiler/ClickListener.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/libs/molecules/src/lib/components/spoilers/TextSpoiler/ClientButton.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/libs/molecules/src/lib/components/spoilers/TextSpoiler/style.css");
;
import(/* webpackMode: "eager", webpackExports: ["StickyHeader"] */ "/vercel/path0/libs/molecules/src/lib/components/table-of-contents/StickyHeader.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/libs/organisms/src/lib/components/blocks/how-to/components/OgImage.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/libs/organisms/src/lib/components/blocks/how-to/components/StepMetaTags.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HeightTrackerContainer"] */ "/vercel/path0/libs/organisms/src/lib/components/blocks/how-to/components/TabVariant/HeightTrackerContainer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ClientTimeline"] */ "/vercel/path0/libs/organisms/src/lib/components/blocks/timeline/components/ClientTimeline/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/libs/organisms/src/lib/components/content-carousel/components/CarouselLinkButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ImageGallery"] */ "/vercel/path0/libs/organisms/src/lib/components/content-carousel/components/ImageGallery.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["UnpublishedPlaceholder"] */ "/vercel/path0/libs/organisms/src/lib/components/content-carousel/components/UnpublishedPlaceholder.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/libs/organisms/src/lib/components/content-carousel/variants/Licenses/FullscreenCarousel.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/libs/organisms/src/lib/components/content-carousel/variants/Reviews/FullscreenCarousel.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/libs/organisms/src/lib/components/header/header-compact/HeaderCompact.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SchemaMarkDown"] */ "/vercel/path0/libs/schemas/src/lib/components/SchemaMarkDown.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["IntersectionObserverWrapper"] */ "/vercel/path0/libs/ui-core/src/lib/components/IntersectionObserverWrapper.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
